// Librairies
import React from 'react';
// import { withTranslation } from 'react-i18next';
import { ModuleEncartMt } from './ModuleEncartMt';



// IMAGE :
// largeur : 406px 
// hauteur : 305px


export class ModuleEncartListMt extends React.Component {
	render() {
		const { t, data } = this.props;

		const childElements = data.map(element => {
			return <ModuleEncartMt key={element.imgSrc} element={element} />;
		});

		return (
			<React.Fragment>
				{/* Les images doivent être en 460x305 */}
				<div className="row">{childElements}</div>
			</React.Fragment>
		);
	}
}

